"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DealFeatureCategoryCodes;
(function (DealFeatureCategoryCodes) {
    DealFeatureCategoryCodes["SERVICE_PLANS"] = "serviceplans";
})(DealFeatureCategoryCodes = exports.DealFeatureCategoryCodes || (exports.DealFeatureCategoryCodes = {}));
